import { AufgabeAbschliessenModal } from '@tbitop/ui';
import { isNull } from 'lodash-es';
import { useAufgabe, useAufgabeAbschliessen, useAufgabeZwischenergebnisErfassen } from '../../../infrastructure/graphql';

/**
 * In der mobilen Ansicht des Sales Planners können keine Aufgaben abgeschlossen werden,
 * die nocht nicht durch den Innendienst freigegeben wurden. Wenn sie freigegeben wurden,
 * dann ist das abschließen der Aufgabe nur möglich, wenn kein Ergebnis vorliegt (Aufgabe
 * damit im Status "offen") oder, wenn das Ergebnis "Ungewiss" ist (Aufgabe ist im Status
 * "abgeschlossen").
 */
const canAufgabeAbschliessen = (aufgabe: { status: string | null; ergebnis: string | null}) => (
  (isNull(aufgabe.ergebnis) || aufgabe.ergebnis === 'Ungewiss') &&
  aufgabe.status !== 'Eingestellt'
);

type AufgabeProps = {
  aufgabenId: string;
  onClose: () => void;
  onAfterAction?: () => void;
};

export const Aufgabe = ({ onClose, aufgabenId, onAfterAction }: AufgabeProps) => {
  const { loading, aufgabe } = useAufgabe(aufgabenId);
  const { aufgabeAbschliessen } = useAufgabeAbschliessen();
  const { aufgabeZwischenergebnisErfassen } = useAufgabeZwischenergebnisErfassen();

  return <AufgabeAbschliessenModal
    aufgabe={aufgabe}
    isLoading={loading}
    onClose={onClose}
    onAfterAction={onAfterAction}
    onAufgabeAbschliessen={aufgabeAbschliessen}
    onAufgabeZwischenergebnisErfassen={aufgabeZwischenergebnisErfassen}
    canAufgabeAbschliessen={canAufgabeAbschliessen}
  />;

};
